import { createModule } from '../createModule';

export const projectLaborType = createModule('projectLaborType', {
    url: 'project_labor_type'
});